import { FILE_SOURCE_ICON } from '#pplx/frontend/components/links/internal/sourceIcons.js';
import { $icon } from '#pplx/frontend/icons/icon-sprite.js';
// Mirrors the Files app extension map so attachment cards, link cards and
// file pickers agree on the glyph for a given extension.
const FILE_EXTENSION_ICONS = {
    // Documents
    pdf: $icon('file-type-pdf'),
    doc: $icon('file-type-doc'),
    docx: $icon('file-type-docx'),
    xls: $icon('file-type-xls'),
    xlsx: $icon('file-type-xls'),
    ppt: $icon('file-type-ppt'),
    pptx: $icon('file-type-ppt'),
    csv: $icon('file-type-csv'),
    txt: $icon('file-type-txt'),
    // Web
    html: $icon('file-type-html'),
    css: $icon('file-type-css'),
    xml: $icon('file-type-xml'),
    // Programming languages with brand icons
    py: $icon('brand-python'),
    js: $icon('brand-javascript'),
    mjs: $icon('brand-javascript'),
    cjs: $icon('brand-javascript'),
    jsx: $icon('brand-react'),
    ts: $icon('brand-typescript'),
    tsx: $icon('brand-react'),
    rs: $icon('brand-rust'),
    go: $icon('brand-golang'),
    cpp: $icon('brand-cpp'),
    cc: $icon('brand-cpp'),
    cxx: $icon('brand-cpp'),
    php: $icon('brand-php'),
    swift: $icon('brand-swift'),
    kt: $icon('brand-kotlin'),
    // Other code files
    java: $icon('file-code'),
    c: $icon('file-code'),
    h: $icon('file-code'),
    rb: $icon('file-code'),
    cs: $icon('file-code'),
    scala: $icon('file-code'),
    json: $icon('file-type-js'),
    sql: $icon('file-type-sql'),
    vue: $icon('file-type-vue'),
    // Images
    jpg: $icon('file-type-jpg'),
    jpeg: $icon('file-type-jpg'),
    png: $icon('file-type-png'),
    svg: $icon('file-type-svg'),
    bmp: $icon('file-type-bmp'),
    // Archives
    zip: $icon('file-type-zip'),
};
const DEFAULT_FILE_FOREGROUND_COLOR = 'var(--decoration-neutral-fg-primary)';
// Brand-adjacent accents for the document formats users recognise by colour.
const FILE_EXTENSION_FOREGROUND_COLORS = {
    pdf: '#B30B00',
    doc: '#185ABD',
    docx: '#185ABD',
    xls: '#107C41',
    xlsx: '#107C41',
    ppt: '#F7630C',
    pptx: '#F7630C',
};
const createFileVisualStyle = (color) => ({
    backgroundColor: `rgb(from ${color} r g b / 0.08)`,
    color,
});
const DEFAULT_FILE_VISUAL_STYLE = createFileVisualStyle(DEFAULT_FILE_FOREGROUND_COLOR);
const FILE_EXTENSION_VISUAL_STYLES = Object.fromEntries(Object.entries(FILE_EXTENSION_FOREGROUND_COLORS).map(([extension, color]) => [
    extension,
    createFileVisualStyle(color),
]));
export const getFileIconForExtension = (extension) => {
    if (!extension)
        return FILE_SOURCE_ICON;
    return FILE_EXTENSION_ICONS[extension] ?? FILE_SOURCE_ICON;
};
export const getFileVisualStyleForExtension = (extension) => {
    if (!extension)
        return DEFAULT_FILE_VISUAL_STYLE;
    return FILE_EXTENSION_VISUAL_STYLES[extension] ?? DEFAULT_FILE_VISUAL_STYLE;
};
//# sourceMappingURL=fileTypeVisuals.js.map